import { render, staticRenderFns } from "./PollContentWrapperV2.vue?vue&type=template&id=dc68384c&scoped=true&"
import script from "./PollContentWrapperV2.vue?vue&type=script&lang=js&"
export * from "./PollContentWrapperV2.vue?vue&type=script&lang=js&"
import style0 from "./PollContentWrapperV2.vue?vue&type=style&index=0&id=dc68384c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc68384c",
  null
  
)

export default component.exports